var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import CloseIcon from '@material-ui/icons/Close';
import MUIPaperModal from '@material-ui/core/Paper';
import Grow from '@material-ui/core/Grow';
import cn from 'classnames';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { AppContext } from '../App';
import withThemeSelector from '../withThemeSelector';
import Text from '../Text';
import Spacer from '../../layout/Spacer';
import Row from '../../layout/Row';
import PaperModalBody from './PaperModalBody';
import PaperModalHeader from './PaperModalHeader';
import PaperModalFooter from './PaperModalFooter';
import PaperModalClose from './PaperModalClose';
import useStyles from './PaperModal.styles';
export const PaperModal = (_a) => {
    var { elevation = 3, title, titleIcon, open, showClose = true, className, children, onClose = () => { } } = _a, paperModalProps = __rest(_a, ["elevation", "title", "titleIcon", "open", "showClose", "className", "children", "onClose"]);
    const classes = useStyles();
    const [animateOut, setAnimateOut] = React.useState(false);
    const isOpen = !animateOut && open;
    const { modalRoot } = React.useContext(AppContext);
    const closeModal = React.useCallback(() => {
        setAnimateOut(true);
    }, [setAnimateOut]);
    if (!modalRoot)
        return null;
    return ReactDOM.createPortal(_jsx(Grow, Object.assign({ in: isOpen, style: { transformOrigin: 'center bottom' }, onExited: () => {
            onClose();
            setAnimateOut(false);
        } }, { children: _jsxs(MUIPaperModal, Object.assign({ className: cn(classes.root, className), elevation: elevation }, paperModalProps, { children: [_jsxs("div", Object.assign({ className: classes.header }, { children: [_jsxs(Row, Object.assign({ halfMargin: true, center: true, className: classes.title }, { children: [titleIcon && (_jsx("span", Object.assign({ className: classes.titleIcon }, { children: titleIcon }))), title && (_jsx(Text, Object.assign({ small: true, muted: true, ellipsis: true }, { children: title })))] })), _jsx(Spacer, {}), showClose && (_jsxs(PaperModalClose, Object.assign({ onClick: closeModal }, { children: [_jsx(CloseIcon, {}), "Close"] })))] })), children] })) })), modalRoot);
};
export default Object.assign(withThemeSelector(PaperModal), {
    Header: PaperModalHeader,
    Body: PaperModalBody,
    Footer: PaperModalFooter,
});
//# sourceMappingURL=PaperModal.js.map